module.exports = {
  name: 'button', base: '_parent', prototype: {
    element_selector: 'input[type=button], button, .button'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/button.js
 ** module id = 9
 ** module chunks = 0
 **/